import * as actionTypes from '../../../constants/actionTypes';
import IntlMessages from '../../../util/IntlMessages';
import * as router from '../../../constants/router';
import * as constants from '../../../constants';
import * as loginApi from '../../../api/login';
import * as regex from '../../../util/regex';
import * as tools from '../../../util/tools';
import * as db from '../../../util/db';
import * as common from '../common';
import * as field from '../field';
import * as info from '../info';

export const operatorLoginAction = () => async (dispatch, getState) => {
  let state = getState().field;
  let data = {
    vPassword: state.password,
    vMobileNumber: state.mobile,
    vAppVersion: tools.getVersion(),
  };
  dispatch({ type: actionTypes.LOADING_BTN, payload: true });
  if (validationForm(data)) {
    let result = await loginApi.operatorLogin(data);
    if (result.status) {
      dispatch(loginData(result.data[0]));
      dispatch(info.applicationConfigAction());
    } else {
      dispatch(common.snackbarAction(true, result.message));
    }
  } else
    dispatch(common.snackbarAction(true, <IntlMessages id="starredFieldsAreRequired" />));
  dispatch({ type: actionTypes.LOADING_BTN, payload: false });
};

export const validateTokenAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.LOADING_BACKDROP, payload: true });
  let token = db.getConfig();
  if (token) {
    let result = await loginApi.getAuthTokenUser();
    if (result.status) {
      dispatch({ type: actionTypes.LOGIN, payload: result.data[0].vMobileNumber });
      dispatch({ type: actionTypes.LOADING_BACKDROP, payload: false });
    } else {
      dispatch(logoutAction());
      dispatch({ type: actionTypes.LOADING_BACKDROP, payload: false });
    }
  } else {
    dispatch(logoutAction());
    dispatch({ type: actionTypes.LOADING_BACKDROP, payload: false });
  }
};

export const logoutAction = () => async (dispatch, getState) => {
  const loadingBackdrop = getState().common.loadingBackdrop;
  let config = db.getConfig();
  if (config) loginApi.userLogout({ iPersonType: constants.PERSON_TYPE });
  db.deleteConfigs();
  dispatch({ type: actionTypes.LOGOUT });
  dispatch(common.redirectAction(router.LOGIN));
  dispatch(field.setFields([{ field: 'empty_profile' }]));
  dispatch(common.navigationAction(0));
  if (loadingBackdrop) dispatch({ type: actionTypes.LOADING_BACKDROP, payload: false });
};

const loginData = (params) => (dispatch) => {
  Promise.all([db.deleteConfigs(), db.createConfig(params.authorization)]);
  dispatch({ type: actionTypes.LOGIN, payload: params.vMobileNumber });
  dispatch({ type: actionTypes.REDIRECT, payload: router.HOME });
};

const validationForm = (data) =>
  data.vPassword !== '' && regex.MOBILE.test(data.vMobileNumber) ? true : false;
